// test2666
(2666 && 0);
